import appConfig from 'config/app'

/**
 * 调用云函数 (通过 HTTPS 触发)
 * @description 需在云开发控制台配置该云函数的 HTTP 访问服务
 * @param data 参数
 */
export const callCloudFunction = async (data?: any) => {
    // 这里假设已经在云开发控制台配置了 HTTP 触发路径为 /api/[cloudFunctionName]
    // 并且如果是同一个域名的话可以直接用相对路径，从而不在前端暴露 envId

    try {
        const resp = await fetch(appConfig.cloudFunctionHTTP, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })

        if (resp.ok) {
            const json = await resp.json()
            // 云开发 HTTP 触发通常会直接返回函数的 return 值
            return json
        }
        return undefined
    } catch (e) {
        console.error('HTTPS request to cloud function failed', e)
        return undefined
    }
}

/**
 * 获取云存储的访问链接
 * @param url 云存储的特定url
 */
export const getTcbUrl = (url?: string) => {
    if (!url) return ''

    if (!url.startsWith("cloud://")) {
        return url
    }

    const re = /cloud:\/\/.*?\.(.*?)\/(.*)/
    const result = re.exec(url) as any
    return `https://${result[1]}.tcb.qcloud.la/${result[2]}`
}